import { GrowthTimelineResult, LgcEditorGroup, TimelineMilestoneKind } from '../types/financialPlan';

export const EDITOR_GROUPS: { id: LgcEditorGroup; label: string }[] = [
  { id: 'you', label: 'You' },
  { id: 'money', label: 'Money' },
  { id: 'goals', label: 'Goals' },
  { id: 'retirement', label: 'Retirement' },
];

export const EDITOR_GROUP_LABELS: Record<LgcEditorGroup, string> = {
  you: 'You',
  money: 'Money',
  goals: 'Goals',
  retirement: 'Retirement',
};

export function editorGroupFromMilestone(kind: TimelineMilestoneKind): LgcEditorGroup {
  if (kind === 'retirement' || kind === 'planEnd') return 'retirement';
  if (kind === 'college' || kind === 'k12Start' || kind === 'k12End' || kind === 'medicare') {
    return 'goals';
  }
  return 'money';
}

/** Map a pinned timeline age to the editor group a typical user should open. */
export function editorGroupFromPinnedAge(
  timeline: Pick<GrowthTimelineResult, 'milestones' | 'incomePhases' | 'retirementAge'>,
  age: number,
): LgcEditorGroup {
  const atAge = timeline.milestones.filter((m) => m.age === age);
  if (atAge.some((m) => m.kind === 'retirement' || m.kind === 'planEnd')) return 'retirement';
  if (
    atAge.some(
      (m) =>
        m.kind === 'college' ||
        m.kind === 'k12Start' ||
        m.kind === 'k12End' ||
        m.kind === 'medicare',
    )
  ) {
    return 'goals';
  }
  if (timeline.incomePhases.some((p) => p.startAge === age)) return 'money';
  if (age >= timeline.retirementAge) return 'retirement';
  return 'money';
}
